import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchCompanies, deleteCompany } from "actions/company";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class CompanyIndex extends Component {
  componentDidMount() {
    this.props.fetchCompanies();

    this.search = {};
  }

  fetchCompaniesWithSearchTerm() {
    const { companyURL: company_url } = this.props.match.params;
    this.props.fetchCompanies({ company_url, ...this.search });
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.fetchCompaniesWithSearchTerm();
  };

  onPaginationClick = page => event => {
    const { companyURL: company_url } = this.props.match.params;
    this.props.fetchCompanies({ company_url, page, ...this.search });
  };

  handleCompanyDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteCompanyProcess(id);
      },
      title: "Delete Company",
      body: "Are you sure you want to delete this company?"
    });
  };

  deleteCompanyProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteCompany, match } = this.props;
    const { companyURL: company_url } = match.params;
    deleteCompany(id, { company_url })
      .then(() => {
        this.fetchCompaniesWithSearchTerm();
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Company Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { companies } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table companies={companies} onClickDelete={this.handleCompanyDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={companies.current_page}
            lastPage={companies.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, companies, confirmationPopupActive }) => ({
  authUser,
  companies,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchCompanies, deleteCompany, toggleconfirmationPopup, toggleNotification }
)(CompanyIndex);



// WEBPACK FOOTER //
// ./src/pages/Company/Index/index.js